<template>
  <div class="applyNote" style="width: 100%;padding: 10px;">
    <div class="header" style="width:100%;height:60px;line-height:60px;text-align:center;position:relative;border-bottom:1px solid #969696">
      <div class="logo" style="width:110px;line-height:50px;display:inline-block;position:absolute;left:0;">
        <img src="../../assets/img/appLogo.png" alt="" style="width: auto;height: auto;max-width: 100%;max-height: 100%;">
      </div>
      <span style="font-size: 18px;font-weight: 600;">{{project.hospitalName}}检验报告申请单</span>
    </div>
    <div class="baseInfo" style="width: 100%;padding: 10px;display: flex;justify-content: space-between;flex-flow: nowrap row;position: relative;">
      <ul style="display: flex;justify-content: space-between;flex-flow: wrap row;">
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">姓名：</span>
          <span style="font-size: 14px;">{{project.patientName}}</span>
        </li>
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">性别：</span>
          <span style="font-size: 14px;">{{project.sex}}</span>
        </li>
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">科室：</span>
          <span style="font-size: 14px;" class="text">{{project.departmentName}}</span>
        </li>
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">床号：</span>
          <span style="font-size: 14px;min-width: 100px;height: 90%;" class="text"></span>
        </li>
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">就诊号：</span>
          <span style="font-size: 14px;min-width: 100px;height: 90%;" class="text">{{project.diagnosisNo}}</span>
        </li>
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">年龄：</span>
          <span style="font-size: 14px;">{{project.age}}{{project.ageUnit}}</span>
        </li >
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;">送检医生：</span>
          <span style="font-size: 14px;">{{project.doctorName}}</span>
        </li>
        <li style="width: 25%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="font-size: 14px;min-width: 70px;">下单时间：</span>
          <span style="font-size: 14px;">{{project.diagnosisTime}}</span>
        </li>
        <li style="width: 50%;min-width: 60px;height: 30px;line-height: 30px;display: flex;justify-content: flex-start;">
          <span style="min-width: 70px;font-size: 14px;">临床诊断：</span>
          <span style="font-size: 14px;min-width: 300px;width: 50%;" class="text">{{project.diagnosis}}</span>
        </li>
      </ul>
    </div>
    <div class="projectBox" style="width：100%">
      <ul style="border: 1px solid #c9c9c9;">
        <li style="border-bottom:1px solid #c9c9c9;display: flex;justify-content: space-between;line-height: 40px;">
          <p style="width: 20%;font-size: 14px;font-weight: 500;text-align: center;">项目名称</p>
          <div style="width: 80%;"><span style="font-size: 14px;">{{project.proName}}</span></div>
        </li>
        <li style="border-bottom:1px solid #c9c9c9;display: flex;justify-content: space-between;line-height: 40px;">
          <p style="font-size: 14px;font-weight: 500;width: 20%;text-align: center;">项目明细</p>
          <p style="font-size: 14px;font-weight: 500;width: 20%;text-align: center;">采集容器</p>
          <p style="font-size: 14px;font-weight: 500;width: 20%;text-align: center;">样本类型</p>
          <p style="font-size: 14px;font-weight: 500;width: 20%;text-align: center;">总量</p>
          <p style="font-size: 14px;font-weight: 500;width: 20%;text-align: center;">条形码粘贴处</p>
        </li>
        <li v-for="(pro,index) in project.projectShowItems" :key="index" style="border-bottom:1px solid #c9c9c9;display: flex;justify-content: space-between;line-height: 40px;">
          <p style="width: 20%;font-size: 12px;text-align: center;">{{pro.proNameItem}}</p>
          <p style="width: 20%;font-size: 12px;text-align: center;">{{pro.samplingColor}}</p>
          <p style="width: 20%;font-size: 12px;text-align: center;">{{pro.specimenTypeName}}({{pro.count}}{{pro.unitName}})</p>
          <p style="width: 20%;font-size: 12px;text-align: center;">{{pro.samplingNum}}</p>
          <p style="width: 20%;font-size: 12px;text-align: center;">贴条码处</p>
        </li>
      </ul>
    </div>
    <div class="price" style="display: flex;justify-content: space-between;padding: 10px 10%;">
      <div style="display: flex;margin-right: 20px;">
        <p style="font-size: 14px;line-height: 30px;">样本性状：</p>
        <p style="font-size: 14px;line-height: 30px;">
          <span style="font-size:12px;"><i class="iconfont icon-checkbox-checked"></i>正常</span>
          <span style="font-size:12px;"><i class="iconfont icon-checkbox-checked"></i>脂浊</span>
          <span style="font-size:12px;"><i class="iconfont icon-checkbox-checked"></i>轻度溶血</span>
          <span style="font-size:12px;"><i class="iconfont icon-checkbox-checked"></i>量少</span>
          <span style="font-size:12px;"><i class="iconfont icon-checkbox-checked"></i>其他</span>
        </p>
      </div>
      <p style="display: flex;">
        <span style="display: inline-block;line-height: 30px;font-size: 14px; ">采样时间：</span>
        <span class="text" style="min-width: 100px;height: 24px; display: inline-block;line-height: 30px;font-size: 14px; ">{{project.sampingTime}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { tips,replaceT } from "../../tools";
export default {
  name: 'appnote',
  // props:['project'],
  data () {
    return {
      noChargeId:0,
      project:[]
    }
  },
  mounted(){
    console.log(this.project);
    this.loadList();
  },
  methods:{
    loadList(){
      this.noChargeId = this.$route.query.noChargeId;
      console.log(this.noChargeId);
      
    },
    // 收费详情
    waitChargeDetail(id,params){
      let _this = this;
      waitChargeDetail({
        id:id
      }).then(res =>{
        console.log(res);
        this.myInfo = {};
        this.myInfo.patientName = res.hospitalPatientName;
        this.myInfo.sex = params.sex==1?'男':'女';
        this.myInfo.age = params.age;
        this.myInfo.ageUnit = params.ageUnit;
        this.myInfo.diagnosis = res.diagnosis;
        this.myInfo.mobile = params.mobile;
        this.myInfo.diagnosisTime = replaceT(res.diagnosisTime);
        this.samplingDetail(res.hisProjectIds);
        this.myInfo.doctorName = res.doctorName;
        this.myInfo.sum = params.amount;
        this.myInfo.departmentName = res.departmentName;
        console.log(res.hisProjectVos);
        
        let proArr = [];
        for(let i=0;i<res.hisProjectVos.length;i++){
          proArr.push(res.hisProjectVos[i].projectName);
        }
        console.log(proArr);
        this.myInfo.proName = proArr.join(',');
        
      })
    },
    //通过projectId查询样本
    samplingDetail(ids){
      samplingDetail({
        orderIds:ids
      }).then(res=>{
        console.log(res);
        // this.myInfo.projectShowItems = res;
        let sampArr = []; 
        let sampItems = res;
        
        for(let i=0;i<sampItems.length;i++){
          console.log(sampItems[i].list);
          let subArr = []
          for(let j=0;j<sampItems[i].list.length;j++){
            subArr.push(sampItems[i].list[j].projectName);
          }
          console.log(subArr.join(','));
          this.$forceUpdate();
          this.$set(sampItems[i],'proNameItem',subArr.join(','));
          // sampArr.push(subArr.join(','));
        }
        this.$forceUpdate();
        this.$set(this.myInfo,'projectShowItems',sampItems);
        console.log(sampArr);
        console.log(this.myInfo);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
/* .applyNote{
  width: 650px;
  width: 100%;
  padding: 10px;
}
.applyNote>.header{
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  position: relative;
  border-bottom:1px solid #969696; 
}
.applyNote>.header>.logo{
  width: 110px;
  line-height: 50px;
  display: inline-block;
  position: absolute;
  left: 0;
}
.applyNote>.header>.logo>img{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.applyNote>.header>span{
  font-size: 18px;
  font-weight: 600;
}

.baseInfo{
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-flow: nowrap row;
  position: relative;
}
.baseInfo>ul{
  width: 80%;
  display: flex;
  justify-content: space-between;
  flex-flow: wrap row;
}
.baseInfo>p{
  width: 20%;
  font-size: 12px;
}
.baseInfo>ul>li{
  width: 25%;
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
}
.baseInfo>ul>li:last-child{
  width: 50%;
}
.baseInfo>ul>li:last-child>span:first-child{
  min-width: 70px;
}
.baseInfo>ul>li>span{
  font-size: 14px;
}
.baseInfo>ul>li>span:nth-child(2){
  min-width: 100px;
  height: 90%;
}

.baseInfo>ul>li:last-child>span:nth-child(2){
  min-width: 300px;
  width: 50%;
} */
/* .projectBox{
  width: 100%;
}
.projectBox>ul{
  border: 1px solid #c9c9c9;
}
.projectBox>ul>li:first-child{
  display: flex;
  justify-content: space-around;
  
}
.projectBox>ul>li:first-child>p{
  width: 20%;
  font-size: 14px;
  font-weight: 500;
}
.projectBox>ul>li:first-child>div{
  width: 80%;
}
.projectBox>ul>li:first-child>div>span{
  font-size: 14px;
}
.projectBox>ul>li:nth-child(2)>p{
  font-size: 14px;
  font-weight: 500;
}
.projectBox>ul>li{
  border-bottom:1px solid #c9c9c9; 
  display: flex;
  justify-content: space-between;
  line-height: 40px;
}
.projectBox>ul>li>p{
  width: 20%;
  font-size: 12px;
  text-align: center;
}
.price{
  display: flex;
  justify-content: space-between;
  padding: 10px 10%;
}
.price>div{
  display: flex;
  margin-right: 20px;
}
.price>div>p{
  font-size: 14px;
  line-height: 30px;
}
.price>div>p>span{
  font-size:12px;
}
.price>p>span.text{
  min-width: 100px;
  height: 24px;
}
.price>p>span{
  display: inline-block;
  line-height: 30px;
  font-size: 14px;  
}
.price>p{
  display: flex;
} */
</style>



// WEBPACK FOOTER //
// src/views/common/AppNote.vue